import _                                                            from 'lodash';
import Common                                                       from "../modules/common";
import moment                                                       from 'moment';
import {apiClientWithManagerToken, apiClientWithUserToken, apiList} from "../modules/apiClient";

const CommonMixin = {
  data() {
    return {
      // Call api status
      sending             : false,
      noDataMessage       : Common.messages.errorGet,
      // For show loading spinner
      loadingSpinner      : false,
      // For show delete modal
      showDeleteModal     : false,
      deleteInfo          : null,
      // For show snackbar
      successMessage      : null,
      snackbarDuration    : 4000,
      showSnackBar        : false,
      snackbarErrorMessage: null,
      showSnackBarError   : false,
      // First option of select
      unspecified         : 'null',
      unspecifiedLabel    : '指定なし',
      // For handle errors
      errorMessages       : [],
      validateResponse    : [],
      // For checking fetch detail from api
      fetchDetail         : false,
      // Sort config
      sortKey             : null,
      statusSort          : null,
      columns             : null,
      onBusinessTime      : false,
      // Windows size
      windowInnerHeight   : 1000,
      windowInnerWidth    : 1000,
      expandEtc           : false,
    };
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  },
  mounted() {
    const isAdmin     = this.$route.path.match(/^\/admin\//);
    const serviceName = 'シカクマップ' + (isAdmin === null ? '' : '請求管理');
    document.title    = (this.$route.meta.title ? this.$route.meta.title + ' | ' : '') + serviceName;
    this.verifyTabId();
  },
  methods: {
    onBeforeUnload(event) {
      if (typeof this.saveRefresh === 'function') {
        this.saveRefresh(true);
      }
    },
    scrollToTop() {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 100);
    },
    /**
     * Scroll to selector
     * @param selector
     */
    scrollToSelector(selector) {
      this.$nextTick(() => {
        selector.scrollIntoView();
      });
    },
    /**
     * Get billing method name by code
     *
     * @param billMethod
     * @returns {*}
     */
    getBillMethodName(billMethod) {
      return _.get(Common.billingMethods, billMethod, null);
    },
    /**
     * Get billing via name by code
     *
     * @param billVia
     * @returns {*}
     */
    getBillViaName(billVia) {
      return _.get(Common.billingVia, billVia, null);
    },
    /**
     * Set Flash message snackbar show
     */
    setSnackBar(message) {
      localStorage.setItem(Common.localStorageKeys.snackBarMessage, message)
    },
    /**
     * Get Flash message snackbar show
     */
    getSnackBar() {
      let message = localStorage.getItem(Common.localStorageKeys.snackBarMessage);

      if (message !== null) {
        this.successMessage = message;
        this.showSnackBar   = true;
      }
      localStorage.removeItem(Common.localStorageKeys.snackBarMessage)
    },
    /**
     * Format number
     * @param number
     * @returns ?string
     */
    numberFormat(number) {
      if (_.isNaN(number)) {
        return null;
      }
      const numberFormat = new Intl.NumberFormat();
      return numberFormat.format(number);
    },
    /**
     * Format date time
     * @param datetime
     * @param format
     */
    datetimeFormat(datetime, format = Common.momentConst.dateTimeFormat) {
      return moment(datetime).format(format);
    },
    /**
     * Format postal code XXX-XXXX
     * @param postalCode
     */
    postalCodeFormat(postalCode) {
      if (postalCode && postalCode.length === 7) {
        return [postalCode.substr(0, 3), postalCode.substr(3)].join('-');
      }
      return null;
    },
    /**
     * Check has response errors
     *
     * @param response
     * @return {boolean}
     */
    hasResponseErrors(response) {
      this.validateResponse = [];
      this.errorMessages    = [];
      const result          = response.data;
      if (result.errors) {
        for (let index in result.errors) {
          if (!result.errors[index]['target']) {
            this.errorMessages = result.errors;
            break;
          }
          this.validateResponse = result.errors;
        }
        return true;
      }
      return false;
    },
    /**
     * Get validation class. Error is invalid
     *
     * @param fieldName
     * @param serverFieldName
     * @return {*}
     */
    getValidationClass(fieldName, serverFieldName = null) {
      let fieldKeys = fieldName.split('.');
      let field;
      if (fieldKeys.length === 2) {
        field = this.$v.form[fieldKeys[0]][fieldKeys[1]];
      } else {
        field = this.$v.form[fieldName];
      }

      if (field && (field.$invalid === true && field.$dirty === true)) {
        return {
          'md-invalid': true,
        }
      }
      serverFieldName = serverFieldName === null ? fieldName : serverFieldName;
      return {'md-invalid': this.getValidationResponseMessage(serverFieldName)};
    },
    /**
     * Get response validation error message
     *
     * @param fieldName
     * @return {*}
     */
    getValidationResponseMessage(fieldName) {
      for (let index in this.validateResponse) {
        if (this.validateResponse[index]['target'] === fieldName) {
          return this.validateResponse[index]['message'];
        }
      }
      return null;
    },
    /**
     * Remove response validation error message
     *
     * @param fieldName
     */
    removeValidationResponseMessage(fieldName) {
      this.errorMessages    = [];
      this.validateResponse = this.validateResponse.filter(function (validated) {
        return validated['target'] !== fieldName;
      });
    },
    getDialogValidationClass(fieldName, serverFieldName = null) {
      let fieldKeys = fieldName.split('.');
      let field;
      if (fieldKeys.length === 2) {
        field = this.$v.formDialog[fieldKeys[0]][fieldKeys[1]];
      } else {
        field = this.$v.formDialog[fieldName];
      }

      if (field && (field.$invalid === true && field.$dirty === true)) {
        return {
          'md-invalid': true,
        }
      }
      serverFieldName = serverFieldName === null ? fieldName : serverFieldName;
      return {'md-invalid': this.getValidationResponseMessage(serverFieldName)};
    },
    /**
     * ユーザーのログアウト（SACLMASからもログアウトする）
     */
    logOutUser() {
      const self = this;
      apiClientWithUserToken
        .post(apiList.user.logout)
        .then(response => {
          if (this.hasResponseErrors(response)) {
            return;
          }

          localStorage.removeItem(Common.localStorageKeys.user.accessToken);
          localStorage.removeItem(Common.localStorageKeys.user.accessTokenExpireIn);
          localStorage.removeItem(Common.localStorageKeys.user.auth);
          self.$router.replace({name: 'MapLogin'});
        });
    },
    logOutAdmin() {
      localStorage.removeItem(Common.localStorageKeys.admin.accessToken);
      localStorage.removeItem(Common.localStorageKeys.admin.accessTokenExpireIn);
      this.$router.replace({name: 'BackendAdminLogin'});
    },
    activeRouteClass(routeNames) {
      const currentRoute = this.$route.name;
      return {
        'router-link-active': routeNames.filter(function (routeName) {
          return routeName === currentRoute;
        }).length > 0,
      }
    },
    isSuperUserOrGroupAdmin() {
      return Common.isSuperUser() || Common.isGroupAdmin();
    },
    isSuperUser() {
      return Common.isSuperUser();
    },
    isGroupAdmin() {
      return Common.isGroupAdmin();
    },
    paymentStatusLabel(status) {
      for (let paymentStatus of Common.paymentStatuses) {
        if (paymentStatus.code === status) {
          return paymentStatus.name;
        }
      }
      return null;
    },
    paymentStatusLabelAdmin(status) {
      for (let paymentStatus of Common.paymentStatusesAdmin) {
        if (paymentStatus.code === status) {
          return paymentStatus.name;
        }
      }
      return null;
    },
    /**
     * Sort table
     * @param sortArray
     * @param sortKey
     */
    sortBy: function (sortArray, sortKey = null) {
      if (this.sortKey === null && this.statusSort === null && this.columns) {
        return;
      }
      if (sortArray.length === 0) {
        return;
      }
      if (sortKey === null) {
        // Sort with current status
      } else if (this.sortKey === sortKey) {
        this.statusSort = (this.statusSort === 'desc') ? 'asc' : 'desc'
      } else {
        this.statusSort = this.columns[sortKey]['sort'];
        this.sortKey    = sortKey;
      }
      if (typeof this.saveSortData === 'function') {
        this.saveSortData({
          sortKey   : this.sortKey,
          statusSort: this.statusSort,
        });
      }
      return sortArray.sort((a, b) => {
        const aString = a[this.sortKey] ? a[this.sortKey].toString() : '';
        const bString = b[this.sortKey] ? b[this.sortKey].toString() : '';
        if (this.statusSort === 'desc') {
          return bString.localeCompare(aString);
        }
        return aString.localeCompare(bString);
      })
    },
    /**
     * ウィンドウのサイズを取得
     */
    getWindowInnerSize() {
      this.windowInnerHeight = window.innerHeight;
      this.windowInnerWidth  = window.innerWidth;
    },
    /**
     * 利用規約などを開いた際に、既存メニューを開いたままにするかどうか
     *
     * @returns {boolean}
     */
    showMenuByExpandEtc() {
      // ウィンドウの高さが800pxある場合は開いたままにする
      if (this.windowInnerHeight > 760) {
        return true;
      }
      // 利用規約メニューを開いた際に閉じるかどうか
      return !this.expandEtc;
    },
    /**
     * @return []
     */
    onlyCurrentGroup() {
      const authAccount = Common.getCurrentUserInfo();
      return [{
        level    : 0,
        group_id : authAccount.group.id,
        name     : authAccount.group.name,
        parent_id: null,
      }];
    },
    /**
     * Parse groups
     * @return []
     */
    parsedGroups(groups, level, parentId = null) {
      const parsed = [];
      groups.forEach(group => {
        parsed.push({
          level    : level,
          group_id : group.group_id,
          name     : group.name,
          parent_id: parentId,
        });
        parsed.push(...this.parsedGroups(group.children, level + 1, group.group_id))
      });
      return parsed;
    },
    /**
     * 認証済みのアカウント情報を取得し、タブ識別IDが異なればログイン画面へ遷移させる
     */
    verifyTabId() {
      const self = this;
      // 開いた画面が、ログイン画面の場合、
      // ログイン後以降の画面（/map, /user/*）ではない場合は対象外
      if (this.$route.path === '/map/login' ||
        (!this.$route.path.startsWith('/map') && !this.$route.path.startsWith('/user'))) {
        return;
      }

      // タブ識別IDが異なれば、ログイン画面へ遷移させエラーメッセージを表示する
      apiClientWithUserToken
        .get(apiList.jon.accounts.auth)
        .then(response => {
          if (this.hasResponseErrors(response)) {
            return;
          }
          if (response.data.activity.last.tab_id === sessionStorage.tabID && sessionStorage.tabCount <= 1) {
            return;
          }

          localStorage.setItem(Common.localStorageKeys.user.errorForceLogin, Common.messages.errorDuplicateWindow);
          self.$router.push({name: 'MapLogin'}).then()
            .catch(error => {
              if (error.name !== 'NavigationDuplicated' &&
                !error.message.includes('Avoided redundant navigation to current location')) {
                console.error(error);
              }
            });
        });
    },
    /**
     * @param params
     * @returns {string}
     */
    generateQueryParams(params) {
      return Object.keys(params).map(function (key) {
        return [key, params[key]].map(encodeURIComponent).join('=');
      }).join('&');
    },
    downloadPdf(registry, corporationId = null) {
      const windowReference = window.open();
      // Trial pdf download
      if (registry.id === undefined || registry.id === null) {
        windowReference.location = registry.pre_signed_url;
        return;
      }
      const partURLs = [apiList.jon.download, registry.id, corporationId];
      const client   = corporationId ? apiClientWithManagerToken : apiClientWithUserToken;
      client
        .get(partURLs.filter(p => p).join('/'))
        .then(response => {
          if (this.hasResponseErrors(response)) {
            this.errorMessages = [Common.messages.pdf.downloadError];
            return;
          }
          windowReference.location = response.data.url;
        })
        .catch(error => {
          this.errorMessages = [Common.messages.pdf.downloadError];
        });
    },
  },
};

export default CommonMixin;
